import { Footer, Header } from "../../components";
import { HeaderType } from "../../components/Header/Header";
import { Section } from "../../components/common";
import { CheckboxFieldStyle } from "../../components/common/CheckboxField/CheckboxField.style";
import { PrivacyPolicyStyle } from "../PrivacyPolicy/PrivacyPolicy.style";
import { DisclaimerStyle } from "./Disclaimer.style";

const Disclaimer = () => {
  return (
    <PrivacyPolicyStyle>
      <DisclaimerStyle>
        <Header
          heading="Stay Connected with Super Hauling Inc"
          image="/images/banners/terms-and-conditions.png"
          type={HeaderType.inner}
        />

        <Section className="testimonial-wrapper">
          <p>
            We value our customers and want to keep you informed with the latest
            updates, exclusive offers, and important notifications. By
            subscribing to our messaging service, you can receive these updates
            directly to your phone. Simply check the box below to opt in.
          </p>

          <p className="agree-wrapper">
            <CheckboxFieldStyle name="agreeToTerms" /> I agree to receive
            recurring messages from Super Hauling Inc.
          </p>

          <h3>Consent Disclosure:</h3>
          <p>
            By checking this box, you agree to receive recurring conversational
            SMS messages from Super Hauling Inc. Reply STOP to opt out.
            Reply HELP for help. Message frequency varies. Message and data
            rates may apply. Carriers are not liable for delayed or undelivered
            messages. Consent is not a condition of purchase. For assistance,
            contact us at Email:{" "}
            <a href="mailto:info@superspeedhauling.us">
              info@superspeedhauling.us
            </a>{" "}
            or call{" "}
            <a href="tel:+18886939563" target="_blank" rel="noreferrer">
              (888) 693-9563
            </a>
            .
          </p>

          <p>
            SMS consent and phone numbers collected for SMS communication
            purposes will not be shared with any third party or affiliates for
            marketing purposes.
          </p>

          <h3>How It Works:</h3>
          <ol>
            <li>
              <b>Subscribe:</b> Opt in by checking the box and providing your
              phone number.
            </li>
            <li>
              <b>Receive Messages:</b> Stay updated with messages related to
              quotes, scheduling, dispatch updates, pickup and delivery
              notifications, appointment reminders, and customer support.
            </li>
            <li>
              <b>Manage Subscription:</b> You can stop receiving messages at any
              time by replying STOP. For assistance, reply HELP or contact us at{" "}
              <a href="tel:+18886939563" target="_blank" rel="noreferrer">
                (888) 693-9563
              </a>{" "}
              or{" "}
              <a href="mailto:info@superspeedhauling.us">
                info@superspeedhauling.us
              </a>
              .
            </li>
          </ol>
        </Section>

        <Footer />
      </DisclaimerStyle>
    </PrivacyPolicyStyle>
  );
};

export default Disclaimer;


